import { createApiInstance } from './config'

const itemPriceDataAPI = createApiInstance()

export default {
  // 搜索道具名称（24小时内）
  searchItems(keyword = '') {
    return itemPriceDataAPI.get('/item-price-data/search-items', {
      params: { keyword }
    })
  },
  
  // 获取指定道具在各大区的最新价格（24小时内）
  getLatestPrices(itemName) {
    return itemPriceDataAPI.get('/item-price-data/latest-prices', {
      params: { itemName }
    })
  },
  
  // 获取指定道具在指定大区的历史价格（最多30天）
  getPriceHistory(itemName, region) {
    return itemPriceDataAPI.get('/item-price-data/price-history', {
      params: { itemName, region }
    })
  }
}

